import HomePage from './pages/home';

const routes = [{ path: '/', component: HomePage, exact: true }];

export default routes;
